<template>
  <div>
    <div class="">
      <ul class="nav nav-tabs">
        <li v-for="item in tabs" :key="item.id" class="nav-item">
          <router-link
            :to="{name: 'Sale', params: { tab: item.id }}"
            >
            {{ item.title }}
          </router-link>
        </li>
      </ul>
      <div class="flexbox">
        <label v-for="item in tabs" :key="item.id" :class="{ 'active': tab === item.id }" class="line"></label>
      </div>
    </div>
  </div>
</template>

<script>
import tabs from '@/common/sale-tabs'

export default {
  props: {
    tab: {
      type: String,
      default: ''
    }
  },
  computed: {
    tabs () {
      return tabs
    }
  }
}
</script>
<style scoped>
.nav-tabs {
  border-bottom: unset;
}
.nav-item {
  text-align: center;
  width: 200px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-bottom: 3px solid #008cc6;
}
.nav-item a {
  color: #000;
  background-color: #fff;
}
.nav-item a.router-link-active {
  color: #fff;
  background-color: #008cc6;
}
.nav-tabs > li > a {
  margin-right: 0;
}
.line::after {
  content: "";
  width: 200px;
  display: block;
  margin: 5px 0 0 0;
}
.active.line::after {
  border-bottom: 3px solid #008cc6;
}
@media screen and (max-width: 1024px) {
  .line {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/NavTabs.vue